













































































































































































































































































































































































     
  import {Component, Vue} from "vue-property-decorator";
  import SwiperCarousel from "@/components/SwiperCarousel.vue";
  import "@/plugins/metaHeadful";

  @Component({
    components: {
      SwiperCarousel
    }
  })

  export default class About extends Vue {


    /*mainCarousel: any = {
      slides: [
        {image: 'assets/static/pages/about/slide1.jpg'}
      ],
      breakpoints: {
        1280: {
          slidesPerView: 1,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 16
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20
        }
      }
    };*/
    team: any[] = [
        {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595609076/production/about/team/matteo-ranghetti.jpg',
        name: 'Matteo Ranghetti',
        role: 'Co-Founder & CEO'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595609076/production/about/team/filippo-galanti.jpg',
        name: 'Filippo Galanti',
        role: 'Co-Founder & Business Development'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595609077/production/about/team/andre-luiz-silva.jpg',
        name: 'Andre Luiz Silva',
        role: 'CTO & Wine Teller'
      },
       {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595609076/production/about/team/jacopo-vigorita.jpg',
        name: 'Jacopo Vigorita',
        role: 'Digital Product Manager'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595609077/production/about/team/anna-malacrida.jpg',
        name: 'Anna Malacrida',
        role: 'Winery Account & Customer Care'
      },
      {
        image:'https://res.cloudinary.com/divinea/image/upload/v1596035509/production/about/team/stefano-vukosavljevic.jpg',
        name: 'Stefano Vukosavljevic',
        role: 'Front-end Developer'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595609077/production/about/team/beatrice-zucconi.jpg',
        name: 'Beatrice Zucconi',
        role: 'Social Media Manager'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595609076/production/about/team/lorenzo-pelardi.jpg',
        name: 'Lorenzo Pelardi',
        role: 'Sales & Operations'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595858611/production/about/team/Carlo-Rossi-Chauvenet.jpg',
        name: 'Carlo Rossi Chauvenet',
        role: 'Advisor & Co-founder'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595858423/production/about/team/veronica-mariani.jpg',
        name: 'Veronica Mariani',
        role: 'Advisor'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595858513/production/about/team/gianluca-cocco.jpg',
        name: 'Gianluca Cocco',
        role: 'Advisor'
      }
    ];

medias: any[] = [
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604689/production/about/press/business-insider-logo.png',
        link: 'https://it.businessinsider.com/vino-enoturismo-cantine-digitale-tech-divinea/&ust=1596015540000000&usg=AOvVaw3jBmJW258cb8ASuELP_IVK&hl=it',
        alt: 'Business Insider Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604688/production/about/press/corriere-della-sera-logo.png',
        link: 'https://corriereinnovazione.corriere.it/cards/start-up-si-mobilitano-corsi-gratuiti-fitness-universita-lingue-raccolte-fondi/divinea-degustazione-vini-casa-con-enologo.shtml',
        alt: 'Corriere Della Sera Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604687/production/about/press/wine-meridian-logo-def.png',
        link: 'https://www.winemeridian.com/news_it/enoturismo_e_smart_tasting_potr_il_digitale_contenere_gli_effetti_pandemia__4077.html',
        alt: 'Wine Meridian Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604689/production/about/press/wired-logo.png',
        link: 'https://www.wired.it/lifestyle/food/2020/03/13/smart-tasting-degustazione-distanza-videochiamata/',
        alt: 'Wired Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604689/production/about/press/gq-logo.png',
        link: 'https://www.gqitalia.it/lifestyle/article/weekend-mete-italia-vino-cantine',
        alt: 'GQ Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604689/production/about/press/gambero-rosso-logo.png',
        link: 'https://res.cloudinary.com/divinea/image/upload/v1596040345/production/about/press/gambero-rosso-articolo.pdf',
        alt: 'Gambero Rosso Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604688/production/about/press/agi-italia-logo.png',
        link: 'https://www.agi.it/economia/news/2020-02-19/divinea-startup-turismo-enogastronomico-7128935/',
        alt: 'AGI Italia Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604687/production/about/press/panorama-logo.png',
        link: 'https://www.panorama.it/divinea-sito-prenotare-esperienze-vino',
        alt: 'Panorama Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604687/production/about/press/startup-italia-logo.png',
        link: 'https://startupitalia.eu/116569-20191019-nasce-divinea-la-piattaforma-online-di-turismo-enologico-esperienziale',
        alt: 'Startup Italia Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604687/production/about/press/food-community-logo.png',
        link: 'https://foodcommunity.it/vino-esperienza-digitale-divinea/',
        alt: 'Food Community Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604688/production/about/press/startup-business-logo.png',
        link: 'https://www.startupbusiness.it/smart-tasting-divinea-lancia-la-degustazione-del-vino-in-remoto/103691/',
        alt: 'Startup Business Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604689/production/about/press/tgcom-logo.png',
        link: 'http://avvinando.tgcom24.it/2020/03/28/emergenza-coronavirus-continuano-le-iniziative-del-mondo-del-vino-per-combatterla/',
        alt: 'TGCOM Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604687/production/about/press/so-wine-so-food.png',
        link: 'https://sowinesofood.it/so-wine/come-funziona-lo-smart-tasting-del-vino/',
        alt: 'So Wine So Food Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604687/production/about/press/vny-logo.png',
        link: 'https://www.lavocedinewyork.com/en/food/2020/03/30/italian-wine-market-in-spite-of-everything-still-selling-at-the-time-of-coronavirus/',
        alt: 'La Voce Di New York Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604688/production/about/press/publico-logo.png',
        link: 'https://www.publico.pt/2020/03/20/fugas/noticia/internet-nova-casa-vinhos-portugal-provas-cursos-visitas-virtuais-1908593',
        alt: 'Publico Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595604688/production/about/press/foodmakers-logo.png',
        link: 'https://www.foodmakers.it/divinea-come-cambia-il-turismo-enologico-esperienziale/',
        alt: 'Food Makers Logo'
      }
    ];

partners: any[] = [
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/c_scale,w_200/v1595606887/production/about/partner/strada-del-barolo-logo.jpg',
        link: 'http://www.stradadelbarolo.it/',
        alt: 'Strada del Barolo Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/c_scale,w_200/v1595606887/production/about/partner/chianti-classico-logo.jpg',
        link: 'https://www.chianticlassico.com/',
        alt: 'Chianti Classico Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595606886/production/about/partner/consorzio-tutela-primitivo-di-manduria-logo.jpg',
        link: 'https://www.consorziotutelaprimitivo.com/',
        alt: 'Consorzio Tutela Primitivo Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/c_scale,w_200/v1595606887/production/about/partner/strada-del-vino-latina.jpg',
        link: 'https://www.stradavinolatina.it/',
        alt: 'Strada Vino Latina Logo'
      },      
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/c_scale,w_200/v1595606886/production/about/partner/movimento-turismo-del-vino-lombardia-logo.jpg',
        link: 'http://www.movimentoturismovino.it/it/lombardia/',
        alt: 'Movimento Turismo Vino Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/v1595608155/production/about/partner/credit-agricole-logo.jpg',
        link: 'https://levillagebyca.it/it/',
        alt: 'Credit Agricole Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/c_scale,w_200/v1595608669/production/about/partner/mediaset-logo.jpg',
        link: 'https://www.mediaset.it/',
        alt: 'Mediaset Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/c_scale,w_200/v1595606886/production/about/partner/aci-logo.jpg',
        link: 'http://www.aci.it/',
        alt: 'ACI Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/c_scale,w_200/v1595605877/production/about/partner/nexi-logo-def.jpg',
        link: 'https://www.nexi.it/',
        alt: 'Nexi Logo'
      },
      {
        image: 'https://res.cloudinary.com/divinea/image/upload/c_scale,w_200/v1595605877/production/about/partner/epipoli-logo-def.jpg',
        link: 'https://www.epipoli.com/',
        alt: 'Epipoli Logo'
      }
    ];

  }
